<template>
  <div class="w-full h-full flex flex-col bg-primary-700">
    <div v-if="getCargando" class="w-full flex items-center px-5 h-13 bg-orange-700 left-5">Cargando datos de la factura...</div>
      <div v-if="!getCargando" class="px-4 w-full z-20 bg-primary-700">
        <router-link :to="{name:'documentList', param: this.$route.params.state}" class="w-full flex items-center h-13 hov-arrow-back border-b border-solid border-primary-500">
          <i class="bg-secondary h-6 w-6 flex items-center justify-center rounded transition-200">
            <span class="icon-left text-white text-xs inline-block rounded"></span>
          </i>
          <p class="text-xl sm:text-2xl md:text-3xl font-ligt pl-4"><span class="hidden lg:inline-block">Factura:&nbsp;</span><span class="font-bold">{{ facturaMetadatas.NumeroFactura }}</span></p>
          <span v-bind:class="{ 'bg-success' : facturaMetadatas.Estado === 'Aceptada', 'bg-danger' : facturaMetadatas.Estado === 'Rechazada','bg-alert' : facturaMetadatas.Estado === 'En Trámite'}" class="text-primary-900 text-xs px-2 rounded-lg font-medium ml-4">{{facturaMetadatas.Estado}}</span>
        </router-link>
      </div>
      <!-- mobile -->
      <div v-if="!getCargando" class="w-full h-16 bg-primary-700 flex sticky top-0 xl:hidden z-20 overflow-hidden">
        <!-- <div class="active-tab-bg h-16 bg-primary-900 w-1/2 absolute inline-block z-0" /> -->
        <div @click="activeTab = true" :class="{'clickable-tab':!activeTab}" class="text-light w-1/2 flex justify-center items-center inline-block z-10">
          Datos
        </div>
        <div @click="activeTab = false" :class="{'clickable-tab':activeTab}" class="text-light w-1/2 flex justify-center items-center inline-block z-10">
          Visualizador
        </div>
      </div>
      <!-- end mobile -->
      <div v-if="!getCargando" class="h-full overflow-hidden flex">
        <div :class="{'hidden':!activeTab}" class="xl:inline-block overflow-auto h-full w-1/2 flex-grow">
          <div class="px-2 py-4">
            <div class="flex flex-col pb-4 px-2 w-full">
              <label for="billType" class="text-primary-200 text-sm pb-2">Tipo de factura</label>
              <Input class="only-read" id="billType" disabled placeholder="Tipo de factura" v-model="facturaMetadatas.TipoFactura"/>
            </div>
            <div class="flex items-end">
              <div class="flex flex-col pb-4 px-2 w-7/12 sm:w-5/12 lg:w-6/12 xl:w-7/12">
                <label for="provider" class="text-primary-200 text-sm pb-2">Proveedor (emisor)</label>
                <Input class="only-read" id="provider" disabled placeholder="Proveedor…" v-model="facturaMetadatas.RazonSocial"/>
              </div>
              <!-- <div class="pb-4 px-2 w-2/12 w-5/12 sm:w-3/12 lg:w-2/12 xl:w-3/12">
                <Button class="w-full truncate" size="large" type="primary" icon="el-icon-plus">Nuevo</Button>
              </div> -->
              <div class="flex flex-col pb-4 px-2 w-full sm:w-4/12 lg:w-4/12 xl:w-5/12">
                <label for="cif" class="text-primary-200 text-sm pb-2">CIF Proveedor (emisor)</label>
                <Input class="only-read" id="cif" disabled placeholder="CIF…" v-model="facturaMetadatas.CIF"/>
              </div>
            </div>
            <div class="flex items-end">
              <div class="flex flex-col pb-4 px-2 w-full">
                <label for="company" class="text-primary-200 text-sm pb-2">Empresa (receptor)</label>
                <Input class="only-read" id="company" disabled placeholder="Empresa" v-model="facturaMetadatas.Sociedad"/>
              </div>
              <div class="flex flex-col pb-4 px-2 w-1/2 lg:w-8/12">
                <label for="reciptdate" class="text-primary-200 text-sm pb-2">Fecha de recepción</label>
                <Input class="only-read" id="reciptdate" disabled placeholder="Fecha de recepción" v-model="facturaMetadatas.FechaRecepcionString"/>
              </div>
            </div>
            <div class="pb-4 px-2 w-full">
              <checkbox disabled v-model="facturaMetadatas.Inversion">Inversión Sujeto Pasivo</checkbox>
            </div>
            <div class="flex items-end">
              <div class="flex flex-col pb-4 px-2 w-full">
                  <label for="numberid" class="text-primary-200 text-sm pb-2">Número de factura</label>
                  <Input class="only-read" id="numberid" disabled placeholder="Número de factura" v-model="facturaMetadatas.NumeroFactura"/>
                </div>
                <div class="flex flex-col pb-4 px-2 lg:w-8/12">
                  <label for="date" class="text-primary-200 text-sm pb-2">Fecha de emisión</label>
                  <Input class="only-read" id="date" disabled placeholder="Fecha de emisión" v-model="facturaMetadatas.FechaEmisionString"/>
                </div>
           </div>
            <div class="flex items-end">
             <div class="flex flex-col pb-4 px-2 w-full">
                <label for="total" class="text-primary-200 text-sm pb-2">Total factura</label>
                <Input class="only-read" id="total" disabled placeholder="TOTAL" v-model="facturaMetadatas.TotalFactura"/>
              </div>
               <div class="flex flex-col pb-4 px-2 xl:w-8/12">
                <label for="ocode" class="text-primary-200 text-sm pb-2">Código de obra</label>
                <Input class="only-read" id="ocode" disabled placeholder="Código de obra" v-model="facturaMetadatas.CodigoObra"/>
              </div>
            </div>
            <div class="flex flex-col xl:flex-row">
             
              <div class="flex flex-col pb-4 px-2 xl:w-2/3" v-if="false">
                <label for="ordernumber" class="text-primary-200 text-sm pb-2">Número de pedido</label>
                <Input class="only-read" id="ordernumber" disabled placeholder="Número de pedido" v-model="facturaMetadatas.NumeroPedido"/>
              </div>
            </div>
            <div class="flex flex-col pb-4 px-2 w-full">
              <label for="comments" class="text-primary-200 text-sm pb-2">Comentarios</label>
              <Input type="textarea" class="only-read" id="comments" disabled placeholder="Comentarios" v-model="facturaMetadatas.Comentarios"/>
            </div>
            <div class="pr-4">
              <div class="bg-primary-800 mx-2 mb-4 px-2  py-2 rounded-lg w-full">
                <div class="flex items-center px-2 pb-2">
                  <p class="text-lg sm:text-xl md:text-2xl font-light">Importes</p>
                  <!-- <div class="ml-auto flex">
                    <Button type="primary" size="small" icon="el-icon-plus"><span class="hidden sm:inline-block">Nuevo</span></Button>
                  </div> -->
                </div>
                <div class="flex items-center">
                  <Table
                    :data="amountsData"
                    style="width: 100%">
                    <!-- <TableColumn
                      type="selection"
                      width="55">
                    </TableColumn> -->
                    <TableColumn
                      sortable
                      property="Base"
                      label="Base imponible">
                    </TableColumn>
                    <TableColumn
                      sortable
                      property="Iva"
                      label="Tipo impositivo">
                    </TableColumn>
                    <TableColumn
                      sortable
                      property="Cuota"
                      label="Importe impuesto">
                    </TableColumn>
                  </Table>
                </div>
              </div>
            </div>
            <!-- <div class="pr-4">
              <Collapse class="w-full">
                <Collapse-item title="Trazabilidad" name="trazabilidad"> -->
                <!-- INICIO COMENTARIO -->
                  <!-- <div class="w-full py-3 text-base px-2">
                    <div class="flex items-center flex-wrap">
                      <div class="h-8 w-8 min-w-8 hidden sm:inline-block overflow-hidden rounded-full ml-2">
                        <img class="transition-200" src="~@/assets/img/test-user.png" alt="">
                      </div>
                      <div class="px-2 min-w-60">
                        <div class="flex text-light leading-tight">
                          <p class="font-medium">Richard Tomás</p>
                          <span class="px-2">·</span>
                          <p class="font-light">Contabilidad</p>
                        </div>
                        <p class="text-xs text-primary-200">martes, 24 de septiembre de 2019 10:49</p>
                      </div>
                      <div class="flex ml-auto items-center py-1">
                        <span class="border-primary-200 border border-solid rounded-lg text-xs text-primary-300 px-2">Recibida</span>
                        <span class="el-icon-right px-4" />
                        <span class="border-danger border border-solid rounded-lg text-xs text-primary-300 px-2">Incidencia</span>
                      </div>
                    </div>
                    <div class="w-full relative rounded-r-lg rounded-b-lg overflow-hidden min-h-1 mt-2">
                      <div class="bg-primary-700 w-full p-4 text-primary-200">
                        Mi comentario es todo ok
                      </div>
                      <span class="absolute bottom-0 w-full h-1 bg-danger" />
                    </div>
                  </div> -->
                <!-- la línea de color de debajo debe tener el mismo color que el estado final de la factura -->
                <!-- FIN COMENTARIO -->
                <!-- INICIO COMENTARIO -->
                  <!-- <div class="w-full py-3 text-base px-2">
                    <div class="flex items-center flex-wrap">
                      <div class="h-8 w-8 min-w-8 hidden sm:inline-block overflow-hidden rounded-full ml-2">
                        <img class="transition-200" src="~@/assets/img/test-user.png" alt="">
                      </div>
                      <div class="px-2 min-w-60">
                        <div class="flex text-light leading-tight">
                          <p class="font-medium">Richard Tomás</p>
                          <span class="px-2">·</span>
                          <p class="font-light">Contabilidad</p>
                        </div>
                        <p class="text-xs text-primary-200">martes, 24 de septiembre de 2019 10:49</p>
                      </div>
                      <div class="flex ml-auto items-center py-1">
                        <span class="border-danger border border-solid rounded-lg text-xs text-primary-300 px-2">Incidencia</span>
                        <span class="el-icon-right px-4" />
                        <span class="border-alert border border-solid rounded-lg text-xs text-primary-300 px-2">P.asignación</span>
                      </div>
                    </div>
                    <div class="w-full relative rounded-r-lg rounded-b-lg overflow-hidden min-h-1 mt-2"> -->
                      <!-- <div class="bg-primary-700 w-full p-4 text-primary-200">
                        Los cambios de estado pueden no tener comentario
                      </div> -->
                      <!-- <span class="absolute bottom-0 w-full h-1 bg-alert" />
                    </div>
                  </div> -->
                <!-- la línea de color de debajo debe tener el mismo color que el estado final de la factura -->
                <!-- FIN COMENTARIO -->
                <!-- </Collapse-item>
              </Collapse>
              <Collapse class="w-full">
                <Collapse-item title="Observaciones" name="observaciones"> -->
                <!-- INICIO COMENTARIO -->
                  <!-- <div class="w-full py-3 text-base">
                    <div class="flex items-center">
                      <div class="h-8 w-8 overflow-hidden rounded-full ml-2">
                        <img class="transition-200" src="~@/assets/img/test-user.png" alt="">
                      </div>
                      <div class="pl-2">
                        <div class="flex text-light leading-tight">
                          <p class="font-medium">Richard Tomás</p>
                          <span class="px-2">·</span>
                          <p class="font-light">Contabilidad</p>
                        </div>
                        <p class="text-xs text-primary-200">martes, 24 de septiembre de 2019 10:49</p>
                      </div>
                    </div>
                    <div class="w-full px-2">
                      <div class="bg-primary-700 w-full p-4 mt-2 rounded-r-lg rounded-b-lg text-primary-200">
                        Mi comentario es todo ok
                      </div>
                    </div>
                  </div> -->
                <!-- FIN COMENTARIO -->
                  <!-- <div class="flex flex-wrap lg:flex-no-wrap items-end z-50 pt-4">
                    <transition name="modal-fade-down">
                      <div v-if="addRemarkOpened" class="px-2 w-full">
                        <Input id="remark" v-model="remark" placeholder="Escriba aquí su observación…"/>
                      </div>
                    </transition>
                    <div class="px-2 w-auto ml-auto min-w-60 pt-2">
                      <Button @click="addRemark()" class="w-full truncate" type="primary" icon="el-icon-plus"><span v-if="!addRemarkOpened">Añadir observación</span> <span v-if="addRemarkOpened">Comentar</span></Button>
                    </div>
                  </div>
                </Collapse-item>
              </Collapse>
              <Collapse class="w-full">
                <Collapse-item title="Documentos Adjuntos" name="DAdjuntos">
                  <Upload
                    class="px-2 w-full"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed">
                    <Button size="small" class="upload-button w-full">Haga <span class="text-light font-medium">click</span> para subir archivo</Button>
                    <div slot="tip" class="el-upload__tip pb-2 border-b border-solid border-primary-500">Solo archivos jpg/png con un tamaño menor de 500kb</div>
                  </Upload>
                </Collapse-item>
              </Collapse>
            </div> -->
          </div>
        </div>
        <div :class="{'hidden':activeTab}" class="xl:inline-block relative h-full w-1/2 flex-grow">
          <PDFViewer
            v-bind="{url}"
            @document-errored="onDocumentErrored"
            >
            <PDFUploader
              v-if="enableUploader"
              :documentError="documentError"
              @updated="urlUpdated"
              slot="header"
              class="header-item"
              />
          </PDFViewer>
        </div>
      </div>
       <!-- <div v-if="!getCargando" class="w-full h-12 flex items-center px-4 global bg-primary-800" style="z-index:1">
        <div class="ml-auto">
          <Button size="small" type="danger"><span class="icon-incidencia pr-2"/><span class="hidden sm:inline-block">Devolver</span> a proveedor</Button>
          <Button size="small" type="warning"><span class="icon-aprobacion pr-2"/><span class="hidden sm:inline-block">Enviar</span> a P.Aprobación</Button>  
          <Button size="small" type="primary"><span class="el-icon-download pr-2"/><span class="hidden sm:inline-block">Descargar</span></Button>
        </div>
      </div> -->
     
  </div>
</template>
<script>
import PDFUploader from '@/components/PDFUploader.vue'
import PDFViewer from '@/components/PDFViewer.vue'
import { Input, InputNumber, Select, Option, Button, Table, Checkbox, TableColumn, CollapseItem, Collapse, Upload } from 'element-ui'
import getFactura from '../utils/solpheoGetFactura'
export default {
  created () {
    const { id } = this.$route.params.id
    // const menuSeleccionado = this.state.menuItem
  },
  async mounted () {
    await this.getSolpheoFactura()
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    Collapse,
    PDFUploader,
    PDFViewer,
    Select,
    Option,
    Checkbox,
    Input,
    Table,
    TableColumn
  },
  data () {
    return {
      url: '',
      facturaMetadatas: {},
      documentArray: null,
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      approvalDepartment: 'Seleccione un departamento',
      approvalDepartments: ['Compras', 'Contabilidad', 'Legal'],
      billTypes: [
        'ASIENTOS CONTABLES (suministros, arrendamientos, servicio externo, Compras)',
        'Lo que sea CONTABLES (suministros, arrendamientos, servicio externo, Compras)',
        'ASIENTOS Lorem ipsum (suministros, arrendamientos, servicio externo, Compras)',
        'ASIENTOS CONTABLES (A lot of things)',
        'ASIENTOS Lorem ipsum dolor sit amet consectetur adipiscing elit',
        'Imaginarias'],
      amountsData: [],
      billType: '',
      provider: '',
      amount: '',
      company: '',
      businessName: '',
      addRemarkOpened: false,
      remark: '',
      cif: '',
      activeTab: false,
      getCargando: true
    }
  },

  methods: {
    async getSolpheoFactura () {
      try {
        const { Estado, Mensaje, Factura, FacturaMetadatas, ListaImpuestos } = await getFactura(this.id)
 
        if (Estado === 'KO' || !Estado) {
          if (Mensaje === 'Token caducado'){
            alert('Sesión Caducada, por favor, inicie sesión nuevamente')
            localStorage.removeItem('token')
            this.$router.push({ name: 'login' })
          }
          else{
            alert('Se produjo un error al obtener la factura para su visualización. Por favor, inténtelo nuevamente accediendo a ella desde el listado de facturas:' + Mensaje)
          }
        }
        this.$store.commit('setFactura', Factura)
        this.facturaMetadatas = FacturaMetadatas
        this.url = 'data:application/pdf;base64, ' + encodeURI(Factura.bytearray)
        this.amountsData = ListaImpuestos
        this.getCargando = false
      } catch (error) {
        alert('Se produjo un error al obtener la factura para su visualización. Por favor, inténtelo nuevamente accediendo a ella desde el listado de facturas:' + Mensaje)
      }
    },
    urlUpdated (url) {
      this.documentError = undefined
      console.log('update')
      this.url = url
    },
    onDocumentErrored (e) {
      this.documentError = e.text
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handlePreview (val) {
    },
    addRemark () {
      this.addRemarkOpened = !this.addRemarkOpened
    },
    // handleRemove (file, fileList) {
    //   console.log(file, fileList)
    // },
    handleExceed (files, fileList) {
      this.$message.warning(`El límite es 3, has seleccionado ${files.length} archivos esta vez, añade hasta ${files.length + fileList.length}`)
    }
  }
}
</script>
